export default "__VITE_ASSET__C55s5xuz__"